export default __webpack_public_path__ + "static/media/10n.df5a4e5b.png";